export default {
  brandAdmin: {
    womens: '女装', mens: '男装', womensApprover: 'EE 女装审批人', mensApprover: 'EE 男装审批人（款号末位 G）',
    mensOnlyEe: '男装审批分流仅适用于 EE。',
    approverFutureOnly: '审批人配置只影响新提交的轮次。已提交的轮次保留原审批人；需要改派时撤回后重新提交。',
    approvalRoundUnassigned: '此历史审批轮次尚未固定审批人，请由设计师撤回后重新提交。',
    designApprover: '设计审批人（设计室长）', noApprovers: '请先在用户管理中设置设计室长角色和本品牌权限。',
    approverUnavailable: '所选设计室长已停用、岗位不符或无本品牌权限，请重新选择。', approverMissing: '请联系管理员设置本品牌的设计审批人。', approverOnly: '此款须由本品牌指定的设计室长审批。',
    title: '品牌管理', desc: '登记当前业务品牌，控制哪些品牌可以进入工作系统。历史资料继续保留。',
    create: '登记品牌', code: '品牌代码', name: '品牌名称', status: '业务状态', enabled: '已启用', disabled: '未启用',
    all: '全部状态', newHint: '新品牌登记后默认为未启用。核对授权人员后，再启用业务。', codeHint: '保存后不能修改品牌代码。',
    enabledHint: '启用后，仅已获该品牌授权的人员可以查看资料。', disabledHint: '停用后，业务资料从列表和查询中隐藏，数量、分工、审批与确认记录继续保留。',
    impact: '保留资料与使用人员', impactSummary: '{sheets} 份当前委托书，其中 {inProgress} 份进行中；{history} 份历史委托书；{users} 位已授权人员。',
    enableConfirm: '启用“{name}”后，已授权人员可使用该品牌资料。确认启用？', disableConfirm: '停用“{name}”后，业务页面将隐藏该品牌资料。{summary} 所有资料和人员授权继续保留。确认停用？',
    saveFailed: '暂时无法保存，填写内容已保留。请稍后重试。', loadFailed: '暂时无法读取品牌，请重试。', empty: '尚未登记业务品牌。请按正式品牌清单登记并启用。', noMatches: '没有符合筛选条件的品牌。',
    history: '修改记录', historyEmpty: '尚无修改记录。', registered: '已登记', updated: '已修改', system: '系统维护',
    discard: '当前修改尚未保存，是否放弃？', required: '请填写品牌代码和名称。',
    codeExists: '品牌代码已登记，请打开现有品牌修改。', notFound: '品牌不存在。', changed: '品牌已被其他人修改。请保留当前内容，刷新核对后重新保存。',
    confirmRequired: '请先核对品牌启停的影响。', grantUnavailable: '新增授权只能选择已启用的业务品牌。',
    noBusinessBrands: '当前没有可用业务品牌。请联系管理员核对品牌启用状态与人员授权。',
  },
  responsibility: {
    patternHint: '版师负责辅料技术信息、尺寸与用量。', cad: '版师', cadHint: '用量与尺寸偏差由本款版师负责。',
    title: '基础分工', desc: '新任务优先沿用款号负责人，缺项使用默认分工。已有款式可单独调整。',
    tasks: '款式分工', taskDesc: '查看各款式的具体负责人，处理未分配和人员变化。订货数量在前序确定后只读查看，无需再次确认。',
    create: '新增分工', brand: '品牌', category: '品类', brandDefault: '品牌默认', active: '使用此分工',
    pendingOnly: '只看待指定或需调整的款式',
    designer: '设计师', planner: '商品企划', purchasing: '面辅料采购', production: '生产管理',
    ruleHint: '款号负责人缺项时，先用品类分工，再用品牌默认。修改只影响后续新任务。',
    peopleHint: '候选人须已启用、角色相符且获本品牌授权。面料与辅料由同一位采购负责。',
    missing: '待指定', personNeedsReview: '原负责人已不符合条件，请重新选择', sheetNotFound: '委托书不存在。', empty: '尚未设定默认分工。可以先设置品牌默认，再补充品类例外。',
    inactive: '暂不使用', match: '匹配结果', preview: '预览分工', matchedDefault: '使用品牌默认', matchedCategory: '使用品类分工',
    noMatch: '未设置默认分工，新任务需有完整的款号负责人。', personUnavailable: '所选人员已停用、角色不符或无本品牌授权，请重新选择。',
    changed: '分工已被其他人修改，请刷新后核对。', categoryUnavailable: '请选择现有品类，来源分类需要先完成对应关系。',
    finalReopen: '更换生产负责人后，已确认的 Tech Pack 将等待新负责人重新确认。设计批准和已填写资料继续保留。确认交接？',
    finalAssignmentHint: 'Tech Pack 已最终确认，当前可办理生产负责人交接。其他岗位继续保留原分工。',
    handoffHint: '交接保留资料、数量和设计审批记录。换入的人员从自己的任务中继续处理。',
    allRequired: '请指定四位负责人。', cancelled: '已作废的委托书不能调整负责人。', savingFailed: '暂时无法保存，选择已保留。请重试。',
    inProgress: '进行中', noPeople: '没有符合条件的人员，请联系管理员核对角色与品牌授权。', updated: '已保存分工',
  },
};
